import { useState } from "react";
import { Pressable } from "react-native";
import { Icon } from "@ant-design/react-native";
import { Text } from "@shared/components/text";
import { colorPalette } from "@shared/config/colorsConfig";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { TutorialsModal } from "./TutorialsModal";

export const TutorialChip = () => {
    const { t } = dynamicTranslations();
    const [visible, setVisible] = useState(false);

    return (
        <>
            <Pressable
                onPress={() => setVisible(true)}
                className="flex-row items-center gap-2 border border-gray-300 bg-white rounded-2xl px-4 py-3"
            >
                <Icon name="play-circle" size={22} color={colorPalette.secondary[600]} />
                <Text className="font-semibold text-base">{t('screens.activities.tutorials.title')}</Text>
                <Icon name="right" size={18} color={colorPalette.gray[500]} />
            </Pressable>

            <TutorialsModal visible={visible} onClose={() => setVisible(false)} />
        </>
    );
};

export default TutorialChip;
